
import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { Button, ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
    selector: 'app-save-button',
    templateUrl: './save-button.component.html',
    styleUrls: ['./save-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ProgressSpinnerModule, NgClass, ButtonModule]
})
export class SaveButtonComponent {


  @Input() label: string = "Save"
  @Input() disabled: boolean = false
  @Input() type: "button" | "submit" = "button"
  @Input() styleClass: string = ""
  @Input() size: Button["size"]
  @Input() severity: Button["severity"] = "primary"

  @Output() saveClick = new EventEmitter<void>()

  saving = signal(false)


  constructor(
    private chRef: ChangeDetectorRef
  ) {}

  buttonClick() {
    this.saving.set(true) ;
    this.disabled = true
    this.saveClick.emit()
 
  }

  saveComplete() {
    this.saving.set(false)
    this.disabled = false
    this.chRef.detectChanges()
  }


}
